module.exports = __webpack_public_path__ + "static/2_1_search-2_SL-c5f2dc66b158deb4a3c5856c080a39c4.svg";